import script from "./LessonShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./LessonShow.vue?vue&type=script&setup=true&lang=ts"

import "./LessonShow.vue?vue&type=style&index=0&id=b7ce894e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7ce894e"]])

export default __exports__